import { render, staticRenderFns } from "./GetMore.vue?vue&type=template&id=2146ba48&"
import script from "./GetMore.vue?vue&type=script&lang=js&"
export * from "./GetMore.vue?vue&type=script&lang=js&"
import style0 from "./GetMore.vue?vue&type=style&index=0&id=2146ba48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports